import Vue from 'vue'
import Vuex from 'vuex'
import nav from './nav'
import money from './money'
import user from './user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    nav,
    money,
    user,
  },
})
